export const ConfigurationSetWarningCodes = Object.freeze({
    IsFailingCreationHyperfindExecution: 'IsFailingCreationHyperfindExecution',
    IsFailingManagementHyperfindExecution: 'IsFailingManagementHyperfindExecution',
});